import { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { motion } from 'framer-motion'
import { useQuiz } from '../context/QuizContext'
import { lumi } from '../lib/lumi'

export default function LeadCapture() {
  const navigate = useNavigate()
  const { setLead } = useQuiz()
  const [loading, setLoading] = useState(false)
  const [formData, setFormData] = useState({
    nome: '',
    email: '',
    whatsapp: ''
  })

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault()
    setLoading(true)

    try {
      // Salvar lead no contexto
      setLead(formData)
      
      // Navegar para o teste
      navigate('/teste')
    } catch (error) {
      console.error('Erro ao processar formulário:', error)
      alert('Erro ao processar seus dados. Tente novamente.')
    } finally {
      setLoading(false)
    }
  }

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    })
  }

  return (
    <div className="reative-page min-h-screen py-8 px-4 sm:py-12 sm:px-6" style={{ backgroundColor: '#0d0d0f' }}>
      <motion.div
        initial={{ opacity: 0, y: 30 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8 }}
        className="max-w-xl mx-auto"
      >
        <div className="rounded-3xl shadow-2xl p-6 sm:p-10 border border-gray-700" style={{ backgroundColor: '#16161a' }}>
          {/* Bola de cristal */}
          <div className="text-center mb-6 sm:mb-8">
            <div className="text-6xl sm:text-7xl mb-4 sm:mb-6">🔮</div>
            <h1 className="text-3xl sm:text-4xl md:text-5xl font-serif text-white mb-3 sm:mb-4">
              Quase lá!
            </h1>
            <p className="text-base sm:text-lg text-gray-300">
              Preencha seus dados para receber seu resultado personalizado.
            </p>
          </div>

          <form onSubmit={handleSubmit} className="space-y-5 sm:space-y-6">
            <div>
              <label htmlFor="nome" className="block text-base sm:text-lg font-medium text-gray-300 mb-2">
                Nome Completo
              </label>
              <input
                type="text"
                id="nome"
                name="nome"
                required
                value={formData.nome}
                onChange={handleChange}
                className="w-full px-5 py-3 sm:py-4 text-base sm:text-lg border border-gray-600 rounded-xl focus:ring-2 focus:ring-purple-500 focus:border-purple-500 transition-all text-white placeholder-gray-500"
                style={{ backgroundColor: '#1c1c21' }}
                placeholder="Digite seu nome"
              />
            </div>

            <div>
              <label htmlFor="email" className="block text-base sm:text-lg font-medium text-gray-300 mb-2">
                E-mail
              </label>
              <input
                type="email"
                id="email"
                name="email"
                required
                value={formData.email}
                onChange={handleChange}
                className="w-full px-5 py-3 sm:py-4 text-base sm:text-lg border border-gray-600 rounded-xl focus:ring-2 focus:ring-purple-500 focus:border-purple-500 transition-all text-white placeholder-gray-500"
                style={{ backgroundColor: '#1c1c21' }}
                placeholder="seuemail@exemplo.com"
              />
            </div>

            <div>
              <label htmlFor="whatsapp" className="block text-base sm:text-lg font-medium text-gray-300 mb-2">
                WhatsApp
              </label>
              <input
                type="tel"
                id="whatsapp"
                name="whatsapp"
                required
                value={formData.whatsapp}
                onChange={handleChange}
                className="w-full px-5 py-3 sm:py-4 text-base sm:text-lg border border-gray-600 rounded-xl focus:ring-2 focus:ring-purple-500 focus:border-purple-500 transition-all text-white placeholder-gray-500"
                style={{ backgroundColor: '#1c1c21' }}
                placeholder="(00) 00000-0000"
              />
            </div>

            <div className="flex items-center gap-2 text-sm sm:text-base text-gray-400 rounded-xl p-3 sm:p-4 border border-gray-700" style={{ backgroundColor: '#1c1c21' }}>
              <span>🔒</span>
              <span>Seus dados estão seguros e não serão compartilhados.</span>
            </div>

            <motion.button
              whileHover={{ scale: 1.02 }}
              whileTap={{ scale: 0.98 }}
              type="submit"
              disabled={loading}
              className="w-full bg-gradient-to-r from-amber-500 to-yellow-500 text-white font-bold py-4 sm:py-5 px-6 sm:px-8 rounded-xl text-base sm:text-xl shadow-lg hover:shadow-2xl transition-all duration-300 disabled:opacity-50"
            >
              {loading ? 'Processando...' : 'DESCOBRIR MEU ELEMENTO BLOQUEADO'}
            </motion.button>
          </form>

          <div className="mt-6 sm:mt-8 text-center text-sm sm:text-base text-gray-600">
            Material exclusivo e protegido. Mônica Maria, Reacenda Luz.
          </div>
        </div>
      </motion.div>
    </div>
  )
}
